export default "__VITE_ASSET__CUNp3aOI__"